import React from "react";
import { Alert, Button, Form, Input } from "antd";
import { ArrowLeftOutlined, MailOutlined } from "@ant-design/icons";
import { useForgotPassword } from "../viewmodels/usePasswordReset";
import { primaryButtonStyle } from "./AuthShell";

export default function ForgotPasswordForm({ onBack }) {
  const { status, message, submit } = useForgotPassword();
  const back = <Button type="link" className="login-link" icon={<ArrowLeftOutlined />} onClick={onBack}>Back to sign in</Button>;
  if (status === "sent") {
    return <>
      <Alert type="success" showIcon style={{ marginBottom: 14, borderRadius: 10 }} message="Check your email" description={message} />
      <p className="login-text">The link works once and expires in 30 minutes. If nothing arrives, check spam or ask an administrator.</p>
      <div style={{ textAlign: "center" }}>{back}</div>
    </>;
  }
  return <>
    <p className="login-text" style={{ marginTop: 0 }}>Enter the email address on your account. We'll send a link to set a new password.</p>
    {status === "failed" && <Alert type="error" showIcon message={message} style={{ marginBottom: 18, borderRadius: 10 }} />}
    <Form layout="vertical" onFinish={({ email }) => submit(email)} requiredMark={false} className="login-card-input">
      <Form.Item name="email" rules={[{ required: true, message: "Enter your email" }, { type: "email", message: "Enter a valid email address" }]} style={{ marginBottom: 22 }}>
        <Input size="large" prefix={<MailOutlined />} placeholder="Email" autoComplete="email" autoFocus aria-label="Email" />
      </Form.Item>
      <Button type="primary" htmlType="submit" size="large" block loading={status === "sending"} className="login-signin-btn" style={primaryButtonStyle}>
        Send reset link
      </Button>
    </Form>
    <div style={{ textAlign: "center", marginTop: 16 }}>{back}</div>
  </>;
}
